import { IAutomationAppComponent } from "../../types";
import { schema, schemaFilter, schemaFreeze, schemaMotion, schemaRepairSwitch } from "./types";
import { OverviewPanel,OperatorPanel, ConfigurationPanel } from '.';
import { RiAlarmWarningLine } from "react-icons/ri";


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: RiAlarmWarningLine,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    createConfig:    {
        group: 'DigitalSensors',
        name: "Digital alarm sensor - use this if something goes wrong in the process",
        description: "Digital alarm sensor",
        panel: OverviewPanel,
        defaultProperties: [
            { key: 'AlarmValue', value: true },
        ]
    },
}

export const AppFilter : IAutomationAppComponent = {
    schema: schemaFilter,
    supportsProcessPanel: false,
    Icon: RiAlarmWarningLine,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    createConfig:    {
        group: 'DigitalSensors',
        name: "Filter alarm",
        description: "Filter alarm",
        panel: OverviewPanel,
        defaultProperties: [
            { key: 'AlarmValue', value: true },
        ]
    },
}


export const AppFreeze : IAutomationAppComponent = {
    schema: schemaFreeze,
    supportsProcessPanel: false,
    Icon: RiAlarmWarningLine,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    createConfig:    {
        group: 'DigitalSensors',
        name: "Freeze protection alarm",
        description: "Freeze protection alarm",
        panel: OverviewPanel,
        defaultProperties: [
            { key: 'AlarmValue', value: true },
        ]
    },
}

export const AppRepairSwitch : IAutomationAppComponent = {
    schema: schemaRepairSwitch,
    supportsProcessPanel: false,
    Icon: RiAlarmWarningLine,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    createConfig:    {
        group: 'DigitalSensors',
        name: "Repair switch alarm",
        description: "Repair switch alarm",
        panel: OverviewPanel,
        defaultProperties: [
            { key: 'AlarmValue', value: true },
        ]
    },
}

export const AppMotion : IAutomationAppComponent = {
    schema: schemaMotion,
    supportsProcessPanel: false,
    Icon: RiAlarmWarningLine,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    createConfig:    {
        group: 'DigitalSensors',
        name: "Motion alarm",
        description: "Motion alarm",
        panel: OverviewPanel,
        defaultProperties: [
            { key: 'AlarmValue', value: true },
        ]
    },
}